import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    box-sizing: inherit;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent;
  }
  *:focus {
  outline: 0;
  outline: none;
  }
  html {
    box-sizing: border-box;
    --color-main: ${(props) => props.theme.colors.main};
    --color-mainLight: ${(props) => props.theme.colors.mainLight};
    --color-text: ${(props) => props.theme.colors.textColor};
    --color-textGrey: ${(props) => props.theme.colors.textGrey};
    --color-white: ${(props) => props.theme.colors.whiteColor};
    --font-normal: ${(props) => props.theme.fonts.normal};
    --font-small: ${(props) => props.theme.fonts.small};
    --font-title: ${(props) => props.theme.fonts.title};
    --font-subTitle: ${(props) => props.theme.fonts.subTitle};


    @media ${(props) => props.theme.mediaQueries.small} {
      font-size: 60%;
    }
    @media ${(props) => props.theme.mediaQueries.smallest} {
      font-size: 55%;
    }
  }
  body {
    font-size: 0.875rem;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    line-height: 1.6;
    letter-spacing: 0.3px;
  }
  button {
    background-color: var(--color-main);
    color: #fff;
    cursor: pointer;
    border: 0;
    padding: 1rem 1.5rem;
    border-radius: .5rem;
  }
  a {
    cursor: pointer;
  }
  a, input, textarea, button {
    outline: none;
    text-decoration: none;
    font-family: inherit;
  }
  .MuiTablePagination-spacer {
    display:none;
  }
`;
